import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import auth from '@feathersjs/authentication-client'
import rest from '@feathersjs/rest-client'
import io from 'socket.io-client'
import { CookieStorage } from 'cookie-storage'

const cookieStorage = new CookieStorage({ path: '/', secure: false })

const feathersClient =
  process.env.NODE_ENV === 'staging'
    ? feathers()
      .configure(rest(process.env.VUE_APP_API_URL_REST).fetch(window.fetch))
      .configure(auth({ storage: cookieStorage }))
    : feathers()
      .configure(
        socketio(
          io(process.env.VUE_APP_API_URL, { transports: ['websocket'] })
        )
      )
      .configure(auth({ storage: cookieStorage }))

export default feathersClient
